module.exports = __webpack_public_path__ + "img/木蝴蝶.ab1052fb.jpg";